import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Moment from 'react-moment'
import Loader from '../../common/Loader'
import CustomFooter from '../../common/TableBottom'
import Modal from 'react-responsive-modal'
import ComplaintActionModel from '../Booking/ComplaintAction'

class CruiseComplaint extends React.Component {
  state = {
    country_list: [],
    complaintData: [],
    open: false,
    limit: 10,
    pageNumber: 0,
    disabled: false,
    keyword: '',
    complaintStatus: '',
    country: '',
    date: null,
    isSearching: false,
    isCancelled: false,
    complaintActionModel: false,
    selectedComplaintId: '',
    type: 'C',
  }

  debounceTimeout = null

  componentDidMount() {
    this.getCountries()
    this.getComplaintList()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list:
              localStorage.getItem('loged_In_role') == 'concierge'
                ? res.data.data.filter((ele) => ele.country_short_name === localStorage.getItem('countryShortName'))
                : res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  getComplaintList = async () => {
    this.setState({
      isSearching: true,
      open: true,
      complaintData: [],
    })

    await axios
      .get(Constant.getAPI() + `/admin/get-complaint-list/${this.state.type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          date: this.state.date,
          country: this.state.country,
          status: this.state.complaintStatus,
          keyword: this.state.keyword,
          pageNumber: this.state.pageNumber,
          limit: this.state.limit,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            complaintData: res.data.data,
            open: false,
            disabled: !res.data.data?.length,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
        this.setState({
          open: false,
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  handleChange = (event) => {
    event.persist()
    this.setState(
      {
        [event?.target?.name]: event?.target?.value,
      },
      () => {
        if (event?.target?.name == 'type') {
          this.getComplaintList()
        }
      }
    )
  }

  changeBookingTagAndStatus = async (event, rowData) => {
    const data = {
      complaint_id: rowData[rowData.length - 1],
      status: event.target.value,
      type: this.state.type,
    }

    await this.updateComplaintStatus(data)
  }

  updateComplaintStatus = async (data) => {
    await axios
      .post(Constant?.getAPI() + `/admin/update-complaint`, data, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire('Updated !', 'Complaint Status Updated', 'success')
          this.getComplaintList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  searchData = async () => {
    this.setState(
      {
        limit: 10,
        pageNumber: 0,
      },
      () => {
        this.getComplaintList()
      }
    )
  }

  clearFilters = () => {
    this.setState({
      country: '',
      complaintStatus: '',
      date: '',
      keyword: '',
      limit: 10,
      pageNumber: 0,
      complaintData: [],
    })
  }

  postAction = async (state) => {
    if (!state?.action) {
      Swal.fire('Action is Required!', '', 'error')
      return
    }
    if (!state?.note) {
      Swal.fire('Note is Required!', '', 'error')
      return
    }

    this.setState({
      complaintActionModel: false,
      isLoading: true,
    })

    const data = {
      complaint_id: this.state.selectedComplaintId,
      action: state?.action,
      note: state?.note,
      type: this.state.type,
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint-action', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint updated successfully', 'success')
          this.getComplaintList()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.searchData()
    }
  }

  render() {
    const columns = [
      {
        name: 'booking_id',
        label: 'Booking Id',
        options: {
          filter: true,
          sort: true,
          display: false,
        },
      },
      {
        name: 'order_number',
        label: 'Order No',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, { rowData }) => {
            return (
              <div style={{ textWrap: 'nowrap' }}>
                {this.state.type == 'C' && (
                  <Link to={'booking-ordering/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
                {this.state.type == 'CH' && (
                  <Link to={'chalet-booking-details/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
                {this.state.type == 'E' && (
                  <Link to={'new-evt/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
                {this.state.type == 'S' && (
                  <Link to={'store-bookings-details/' + rowData[0]}>
                    <span className="text-info">{value}</span>
                  </Link>
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'title',
        label: 'Title',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ width: 100 }}>{value}</div> : '--'),
        },
      },
      {
        name: 'description',
        label: 'Description',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 100 }}>{value}</div>
          },
        },
      },
      {
        name: 'status',
        label: 'Status',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, { rowData }) => {
            return (
              <>
                <select
                  style={{ minWidth: 150 }}
                  name="status"
                  className={`form-control
                  `}
                  value={value}
                  onChange={(event) => this.changeBookingTagAndStatus(event, rowData)}
                >
                  {/* <option value={''}>N/A</option> */}
                  <option value="Open">Open</option>
                  <option value="In Progress">In Progress</option>
                  <option value="Resolved">Resolved</option>
                  <option value="Closed">Closed</option>
                </select>
              </>
            )
          },
        },
      },
      {
        name: 'action',
        label: 'Action Taken',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <div style={{ width: 150 }}>{value}</div>
          },
        },
      },
      {
        name: 'created_by',
        label: 'Created By',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'updated_by',
        label: 'Updated By',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value ? <div style={{ textWrap: 'nowrap' }}>{value}</div> : '--'),
        },
      },
      {
        name: 'created_at',
        label: 'Creation Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return (
              <div>
                <Moment format="YYYY-MM-DD hh:mm A">{value}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Action',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <div>
                <i
                  className="f-14 icofont icofont-edit text-dark"
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.setState({ complaintActionModel: true, selectedComplaintId: value })
                  }}
                ></i>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      search: false,
      customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
        return (
          <CustomFooter
            changePage={changePage}
            changeRowsPerPage={changeRowsPerPage}
            disabled={this.state.disabled}
            count={this.state.limit}
            pageNumber={this.state.pageNumber}
          />
        )
      },
      onChangePage: (currentPage) => {
        this.setState(
          {
            pageNumber: currentPage,
          },
          () => {
            this.getComplaintList()
          }
        )
      },
      onChangeRowsPerPage: (numberOfRows) => {
        this.setState(
          {
            limit: numberOfRows,
          },
          () => {
            this.getComplaintList()
          }
        )
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.open ? <Loader open={this.state.open} /> : 'Sorry, No Booking Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <>
        <div className="pcoded-inner-content">
          <Modal
            open={this.state.complaintActionModel}
            onClose={() => {
              this.setState({ complaintActionModel: false })
            }}
            center
          >
            <ComplaintActionModel
              postAction={this.postAction}
              type={this.state.type}
            ></ComplaintActionModel>
          </Modal>
          <div className="main-body">
            <div className="page-wrapper">
              <div className="page-header">
                <div className="row align-items-end">
                  <div className="col-lg-8">
                    <div className="page-header-title">
                      <div
                        className="d-inline"
                        style={{ width: 300 }}
                      >
                        <h4>Complaint List</h4>
                      </div>
                      <select
                        name="type"
                        className="form-control m-l-30"
                        value={this.state.type}
                        onChange={this.handleChange}
                      >
                        <option value={'C'}>CRUISE</option>
                        <option value={'CH'}>CHALET</option>
                        <option value={'E'}>EVENT</option>
                        <option value={'S'}>STORE</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="page-header-breadcrumb">
                      <ul className="breadcrumb-title">
                        <li className="breadcrumb-item">
                          <Link to="/">
                            <i className="feather icon-home"></i>{' '}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Complaint List</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card card-border-default">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">Search</label>
                              <div className="col-md-9">
                                <input
                                  type="text"
                                  id="keyword"
                                  className="form-control"
                                  value={this.state.keyword}
                                  name="keyword"
                                  placeholder="Order No | Title | Status"
                                  onKeyPress={this.handleKeyPress}
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12"
                            style={{ borderBottom: '2px solid #ddd', marginBottom: 16 }}
                          ></div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Complaint Status</label>
                              <div className="col-sm-9">
                                <select
                                  name="complaintStatus"
                                  className="form-control"
                                  value={this.state.complaintStatus}
                                  onChange={this.handleChange}
                                >
                                  <option value={''}>All</option>
                                  <option value="Open">Open</option>
                                  <option value="In Progress">In Progress</option>
                                  <option value="Resolved">Resolved</option>
                                  <option value="Closed">Closed</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-3 col-form-label">Country</label>
                              <div className="col-sm-9">
                                <select
                                  name="country"
                                  className="form-control"
                                  value={this.state.country}
                                  onChange={this.handleChange}
                                >
                                  <option value={''}>All</option>
                                  {this.state.country_list.map((country) => (
                                    <option
                                      value={country.country_short_name}
                                      key={country.country_short_name}
                                    >
                                      {country.country_name_en + '/' + country.country_name_ar}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-md-3 col-form-label">Complaint Date</label>
                              <div className="col-md-9">
                                <input
                                  type="date"
                                  id="date"
                                  className="form-control"
                                  value={this.state.date}
                                  name="date"
                                  onChange={this.handleChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              {this.state.isSearching ? (
                                <button
                                  className="btn btn-sm btn-grd-disabled"
                                  disabled
                                  style={{ width: 150 }}
                                >
                                  Searching...!
                                </button>
                              ) : (
                                <button
                                  style={{ width: 150 }}
                                  onClick={this.searchData}
                                  className="btn btn-sm btn-inverse waves-effect"
                                >
                                  Search
                                </button>
                              )}
                              <button
                                style={{ width: 150, marginLeft: 10 }}
                                onClick={this.clearFilters}
                                className="btn btn-sm btn-inverse waves-effect"
                              >
                                clear
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="page-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="card">
                      <div className="card-block">
                        <div className="dt-responsive table-responsive">
                          <MUIDataTable
                            title={'Complaint List'}
                            className="table-responsive"
                            data={this.state.complaintData}
                            columns={columns}
                            options={options}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default CruiseComplaint
